import { DataFetchingError } from '../../../errors/DataFetchingError';
import { hubfulRpcClient } from '../../../utils/API';
import { getActiveHubTrialsByHubIdRpc } from 'trials-service-types';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../constants/logging';
export const getActiveHubTrials = () => hubfulRpcClient.call(getActiveHubTrialsByHubIdRpc, {}).catch(error => {
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  logger.error(new DataFetchingError('Failed to fetch active hub trials', {
    statusCode: error.status,
    cause: error
  }));
  return [];
});